import React from 'react';

export const VerticalSeparator = (props: any) => {
  const { children, ...rest } = props;
  return (
    <div className="mk-vertical-separator" {...rest}>
      {children}
    </div>
  );
};
